'use client';

import { useState, useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import Link from 'next/link';

const CONSENT_KEY = 'zibarit_cookie_consent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const posthog = usePostHog();

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // Small delay to avoid layout shift on initial render
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    document.cookie = 'zibarit_consent=1; path=/; max-age=31536000; SameSite=Lax';
    posthog?.opt_in_capturing();
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    document.cookie = 'zibarit_consent=0; path=/; max-age=31536000; SameSite=Lax';
    posthog?.opt_out_capturing();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 border-t border-zibarit-marron-secundario/30 bg-zibarit-bone/95 backdrop-blur-sm shadow-[0_-4px_20px_rgba(0,0,0,0.08)] motion-safe:animate-slide-up"
      role="dialog"
      aria-label="Consentimiento de cookies"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center gap-4">
        <p className="text-sm text-zibarit-negro/80 flex-1 text-center sm:text-left">
          Usamos cookies para mejorar tu experiencia y analizar el tráfico.{' '}
          <Link
            href="/cookies"
            className="underline underline-offset-2 text-zibarit-verde-oscuro hover:text-zibarit-verde-secundario transition-colors"
          >
            Política de cookies
          </Link>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={handleReject}
            className="px-5 py-2 text-sm font-bold uppercase tracking-wider rounded-full border border-zibarit-verde-oscuro text-zibarit-verde-oscuro hover:bg-zibarit-verde-oscuro/5 transition-colors"
          >
            Solo esenciales
          </button>
          <button
            onClick={handleAccept}
            className="px-5 py-2 text-sm font-bold uppercase tracking-wider rounded-full bg-zibarit-verde-oscuro text-zibarit-bone hover:bg-zibarit-verde-oscuro/90 transition-colors"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}
